/**
 * Подписи и форматирование отчётов «Скорость сайта».
 *
 * Здесь только отображение. Оценки (good / ni / poor), вердикты и выводы
 * считает сайт и присылает готовыми — пороги Core Web Vitals сюда не
 * копируются, иначе админка и дашборд на сайте начнут расходиться.
 */

export const RUM_METRICS = ['LCP', 'INP', 'CLS', 'TTFB']

export const METRIC_TEXT = {
    LCP: {name: 'Загрузка', hint: 'Когда показался главный контент страницы (LCP)'},
    INP: {name: 'Отклик', hint: 'Сколько ждать реакции на нажатие (INP)'},
    CLS: {name: 'Стабильность', hint: 'Насколько прыгает вёрстка при загрузке (CLS)'},
    TTFB: {name: 'Ответ сервера', hint: 'Когда пришёл первый байт страницы (TTFB)'},
}

export const RATING_TEXT = {
    good: 'Хорошо',
    ni: 'Терпимо',
    poor: 'Плохо',
    unknown: 'Мало данных',
}

// Классы бейджей из tournament-form.scss.
export const RATING_BADGE = {
    good: 'tf-badge--ok',
    ni: 'tf-badge--warn',
    poor: 'tf-badge--danger',
}

export const SEVERITY_TEXT = {
    critical: 'Срочно',
    warning: 'Важно',
    notice: 'Заметка',
    good: 'Хорошо',
}

export const SEVERITY_BADGE = {
    critical: 'tf-badge--danger',
    warning: 'tf-badge--warn',
    notice: 'tf-badge--primary',
    good: 'tf-badge--ok',
}

export const RELEASE_VERDICT = {
    better: {text: 'Быстрее', badge: 'tf-badge--ok'},
    worse: {text: 'Медленнее', badge: 'tf-badge--danger'},
    mixed: {text: 'По-разному', badge: 'tf-badge--warn'},
    same: {text: 'Без изменений', badge: ''},
    'not-enough': {text: 'Мало данных', badge: ''},
}

/** p75 метрики: CLS — безразмерный, остальное — миллисекунды. */
export function formatMetric(metric, value) {
    if (value === null || value === undefined) return '—'
    if (metric === 'CLS') return Number(value).toFixed(2)
    if (value >= 1000) return `${(value / 1000).toFixed(1)} с`

    return `${Math.round(value)} мс`
}

/** Длительность без привязки к метрике: продуктовые метки, API, скрипты. */
export function formatMs(value) {
    return formatMetric('ms', value)
}

export function formatPercent(share, digits = 0) {
    if (share === null || share === undefined) return '—'
    const shown = share > 0 && share < 0.1 && digits === 0 ? 1 : digits

    // «8.0%» читается хуже, чем «8%»: дробная часть нужна только малым долям.
    return `${(share * 100).toFixed(shown).replace(/\.0$/, '')}%`
}

export function formatCount(n) {
    if (n === null || n === undefined) return '—'

    return Number(n).toLocaleString('ru-RU')
}

/**
 * Изменение p75 к прошлому периоду. Незаметное — без стрелки: шум
 * в несколько процентов не должен выглядеть как новость.
 */
export function formatChange(change) {
    if (!change || change.rel === null || change.rel === undefined || !change.significant) return null
    const sign = change.rel > 0 ? '+' : ''

    return {
        text: `${sign}${Math.round(change.rel * 100)}%`,
        direction: change.direction,
    }
}

let regionNames = null

/** Страна по коду ISO: «Казахстан · KZ». */
export function countryLabel(code) {
    if (!code || code === 'unknown') return 'Не определена'
    try {
        regionNames = regionNames || new Intl.DisplayNames(['ru'], {type: 'region'})
        return `${regionNames.of(code) || code} · ${code}`
    } catch (e) {
        return code
    }
}

/**
 * Точка графика в миллисекундах. Сайт отдаёт ключи в UTC: «2026-10-20T13»
 * за час или «2026-10-20» за сутки. Час — настоящий момент времени, а сутки —
 * дата: её ставим на местную полночь, иначе в Алматы точка встала бы на 05:00.
 */
export function timelinePointMs(key) {
    if (key.length > 10) return Date.parse(`${key}:00:00Z`)
    const [y, m, d] = key.split('-').map(Number)

    return new Date(y, m - 1, d).getTime()
}

export function formatDateTime(value) {
    if (!value) return '—'
    const date = new Date(value)
    if (Number.isNaN(date.getTime())) return '—'

    return date.toLocaleString('ru-RU', {day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit'})
}
